module.exports = __webpack_public_path__ + "img/blimpy10.561bdaed.jpg";